import Cookies from 'js-cookie'

const state = Cookies.get('token_id')
export const initialCookie = state ? JSON.parse(state) : {}
